import { useAuth } from 'react-oidc-context';
import { fetchPrintable, repeatBytes } from '../utils/print';
import { printErrorShown, usePrinter } from './usePrinter';

interface PrintDoctorLabelPayload {
  doctorIdForTemplate: string;
  requestId: string;
  orderId: string;
}

export const usePrintDoctorLabel = (): ((
  payload: PrintDoctorLabelPayload,
  count: number,
  onError: () => void,
  onSuccess: () => void
) => Promise<void>) => {
  const auth = useAuth();
  const { print } = usePrinter();

  return async ({ doctorIdForTemplate, requestId, orderId }, count, onError, onSuccess) => {
    try {
      const path = `/rest/doctor-label?${new URLSearchParams({ doctorIdForTemplate, orderId }).toString()}`;
      const labels = await repeatBytes(await fetchPrintable(path, auth.user?.access_token), count);
      if (labels.byteLength > 0) {
        await print(labels, 'label', { title: 'Zuweiseretiketten', requestId, orderId });
      }
      onSuccess();
    } catch (e) {
      if (!printErrorShown(e)) {
        onError();
      }
    }
  };
};
